import Api from "../../apis/api";
import apifactory from "../../apis/apifactory";
import GlobalStrorage from "../../global/GlobalStrorage";
import storagefactory from "../../global/GlobalStrorage";
export default {
  getprojectid() {
    return storagefactory.getProjectID();
  },
  createNewProject(projectname, ownerid) {
    let apiurl = "project/?name=" + projectname + "&ownerid=" + ownerid + "";

    return Api.get(apiurl);
  },

  api_save_project_details(country, brand, level, start_date, end_date, currency) {
    let projectid = this.getprojectid();
    let apiurl = "save_project_details/?project=" + projectid + "&step=1&country=" + country + "&brand=" + brand + "&level=" + level + "&start_date=" + start_date + "&end_date=" + end_date + "&currency=" + currency + "";
    //alert(("api_save_project_details:--" + apiurl);
    return Api.get(apiurl);
  },
  addParameterBySteps(varstep, varparms) {
    //let varproject = storagefactory.getProjectID();
    let apiurl =
      "save_project_details/?project=" + this.getprojectid() + "&step=" + varstep + "&" + varparms;
    ////alert((apiurl);
    return Api.get(apiurl);
  },
  gettheParameterByProjectStep() {

    return apifactory.gettheParameterByProjectStep("1");
  },
  gettheParameterByProjectStepSummary() {
    return apifactory.gettheParameterByProjectStep("2");
  },
  getcppdata_rcpp() {
    let apiurl = "rcpp/?project=" + this.getprojectid() + "&step=1";

    return Api.get(apiurl);
  },
  get_rdata() {
    let apiurl = "rdata/?project=" + this.getprojectid() + "&step=1";

    return Api.get(apiurl);
  },
  get_rscurve() {
    let apiurl = "rscurve/?project=" + this.getprojectid() + "&step=1";

    return Api.get(apiurl);
  },
  get_country() {
    let apiurl = "country";

    return Api.get(apiurl);
  },
  get_country_currency() {
    let apiurl = "country_currency";
    return Api.get(apiurl);
  },
  api_get_available_data() {
    let userid = GlobalStrorage.getloginuserid();
    // let apiurl = "get_available_data/?user_id=" + userid;
    let apiurl = "get_userwise_data_access/?user_id=" + userid;
    //alert((apiurl);
    return Api.get(apiurl);
  },
  api_get_project_data() {
    let apiurl = "get_project_data/?project=" + this.getprojectid() + "&step=1";
    //alert((apiurl);
    return Api.get(apiurl);
  },
  api_get_project_stepOneData() {
    let apiurl = "save_project_details/?project=" + this.getprojectid() + "&step=1";

    return Api.get(apiurl);
  },
  //summary
  get_summary() {
    let apiurl = "summary/?project=" + this.getprojectid() + "&step=2";

    return Api.get(apiurl);
  },
  get_sdataf() {
    let apiurl = "sdataf/?project=" + this.getprojectid() + "&step=2";

    return Api.get(apiurl);
  },
  get_scope() {
    let apiurl = "scope/?project=" + this.getprojectid() + "&step=2";

    return Api.get(apiurl);
  },
  get_rheader() {
    let apiurl = "rdata-headers/?project=" + this.getprojectid() + "&step=1";

    return Api.get(apiurl);
  },

  get_save_step1() {
    let apiurl = "save_step1/?project=" + this.getprojectid();

    return Api.get(apiurl);
  },
  get_save_find_decay() {
    let apiurl = "save_find_decay/?project=" + this.getprojectid();

    return Api.get(apiurl);
  },
};
